<template>
  <router-link
    :to="{ name: 'Booking Profile', params: { id: booking.id } }"
    tag="div"
    class="booking-item md-layout"
  >
    <div class="md-layout-item md-size-80 tour">
      <h6>{{ booking.departure.tour }} | {{ booking.departure.start_date }}</h6>
    </div>

    <div class="md-layout-item md-size-20 booking-id text-right">
      <h6>#{{ booking.id }}</h6>
    </div>

    <div class="md-layout-item md-size-60 lead-booker">
      {{ booking.lead_booker.full_name }}
    </div>

    <div class="md-layout-item md-size-40 value text-right">
      {{ booking.currency.toUpperCase() }}{{ booking.financials.booking_total }}
    </div>

    <div class="md-layout-item md-size-60 booking-date">
      <div class="md-caption">
        Booked: {{ booking.booking_date | formatDateTime }}
      </div>
    </div>

    <div class="md-layout-item md-size-40 value text-right">
      <div class="md-caption">
        {{ booking.financials.status.description }}
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "BookingItem",
  props: {
    booking: { type: Object, required: true }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

.booking-item {
  padding: 3px 0px;
  border-bottom: 1px solid #d2d2d2;
  cursor: pointer;
}

.tour h6,
.booking-id h6 {
  margin: 0;
}
</style>
